// EVENTS : CHARGEMENT DU DOCUMENT
jQuery(document).ready(function() {
    //wc
    /*
    jQuery('.woocommerce-tabs a').unbind('click').click(function(event ){
        event.preventDefault();
        jQuery('.woocommerce-tabs li').removeClass('active');
        jQuery('.woocommerce-tabs .woocommerce-Tabs-panel').slideUp();

        jQuery(this).parent().toggleClass('active');
        var id = jQuery(this).attr('href');
        jQuery(id).stop().slideToggle();
        return false;
    });
    */

});

// EVENTS : SCROLL
jQuery(window).scroll(function() {

});

// EVENTS : RESIZE
jQuery(window).resize(function() {

});
